module.exports = __webpack_public_path__ + "static/media/download.cc9877ff.svg";